import React, { useCallback } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import FormControl from '@material-ui/core/FormControl'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Checkbox from '@material-ui/core/Checkbox'
import TextField from '@material-ui/core/TextField'
import HelperText from './HelperText'

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
  },
  spacer: {
    height: theme.spacing(2),
  }
}))

const EmbedWidget = ({
  field: {
    name,
    value,
  },
  form: {
    setFieldValue,
  },
  touched,
  error,
  item,
}) => {
  const classes = useStyles()

  const {
    enabled = true,
    days = 3,
    slotsPerDay = 1,
  } = value || {}

  const onSetEnabled = useCallback((enabled) => {
    setFieldValue(name, Object.assign({}, value, {
      enabled,
    }))
  }, [
    value, 
  ])

  const onSetDays = useCallback((days) => {
    const numValue = parseInt(days)
    const updateValue = isNaN(numValue) ? days : numValue
    setFieldValue(name, Object.assign({}, value, {
      days: updateValue,
    }))
  }, [
    value, 
  ])

  const onSetSlotsPerDay = useCallback((slotsPerDay) => {
    const numValue = parseInt(days)
    const updateValue = isNaN(numValue) ? days : numValue
    setFieldValue(name, Object.assign({}, value, {
      slotsPerDay: updateValue,
    }))
  }, [
    value, 
  ])

  const title = item.title || name

  return (
    <FormControl component="fieldset" className={ classes.root }>
      <Typography variant="subtitle1">{ title }</Typography>
      <Grid container spacing={ 2 }>
        {
          !item.autoEnabled && (
            <Grid item xs={ 12 }>
              <FormControlLabel
                control={<Checkbox checked={ enabled } onChange={ (e) => onSetEnabled(e.target.checked) } />}
                label="Enabled?"
              />
            </Grid>
          )
        }
        <Grid item xs={ 12 }>
          <TextField
            required
            label="Days"
            type="number"
            value={ days }
            onChange={ e => onSetDays(e.target.value) }
          />
        </Grid>
        <Grid item xs={ 12 }>
          <TextField
            required
            label="Slots per day"
            type="number"
            value={ slotsPerDay }
            onChange={ e => onSetSlotsPerDay(e.target.value) }
          />
        </Grid>
      </Grid>
      <div className={ classes.spacer }></div>
      {
        item.helperText && (
          <HelperText
            helperText={ item.helperText }
            touched={ touched }
            error={ touched && error }
          />
        )
      }
      {
        touched && error && (
          <HelperText
            helperText={ error }
            error
            touched={ touched }
          />
        )
      }
    </FormControl>
  )  
}

export default EmbedWidget